import * as React from 'react';

export const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row' as const,
    height: '100%',
    width: '100%',
    fontFamily: 'var(--component-explorer-font-family)',
    fontSize: 'var(--component-explorer-font-size)',
    color: 'var(--component-explorer-foreground)',
    backgroundColor: 'var(--component-explorer-editor-background)',
  },
  centerArea: {
    display: 'flex',
    flexDirection: 'column' as const,
    flex: 1,
    overflow: 'hidden',
  },
  titleBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '35px',
    minHeight: '35px',
    padding: '0 10px',
    backgroundColor: 'var(--component-explorer-titleBar-activeBackground)',
    color: 'var(--component-explorer-titleBar-activeForeground)',
    borderBottom: '1px solid var(--component-explorer-titleBar-border, var(--component-explorer-panel-border))',
  },
  titleBarSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '2px',
  },
  titleBarCenter: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    fontSize: '13px',
    fontWeight: 400,
  },
  titleBarButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '28px',
    height: '28px',
    border: 'none',
    background: 'transparent',
    color: 'var(--component-explorer-titleBar-activeForeground)',
    cursor: 'pointer',
    borderRadius: '4px',
  },
  titleBarButtonHover: {
    backgroundColor: 'var(--component-explorer-toolbar-hoverBackground)',
  },
  titleBarButtonActive: {
    backgroundColor: 'var(--component-explorer-toolbar-activeBackground)',
    color: 'var(--component-explorer-focusBorder)',
  },
  sidebar: {
    display: 'flex',
    flexDirection: 'column' as const,
    width: '260px',
    minWidth: '200px',
    backgroundColor: 'var(--component-explorer-sideBar-background)',
    borderRight: '1px solid var(--component-explorer-titleBar-border, var(--component-explorer-panel-border))',
  },
  sidebarRight: {
    borderRight: 'none',
    borderLeft: '1px solid var(--component-explorer-titleBar-border, var(--component-explorer-panel-border))',
  },
  sidebarHeader: {
    display: 'flex',
    alignItems: 'center',
    height: '35px',
    minHeight: '35px',
    padding: '0 12px',
    fontSize: '11px',
    fontWeight: 700,
    textTransform: 'uppercase' as const,
    letterSpacing: '0.04em',
    color: 'var(--component-explorer-titleBar-activeForeground)',
    backgroundColor: 'var(--component-explorer-titleBar-activeBackground)',
    borderBottom: '1px solid var(--component-explorer-titleBar-border, var(--component-explorer-panel-border))',
  },
  sidebarContent: {
    flex: 1,
    overflow: 'auto',
    padding: '4px 0',
  },
  treeItem: {
    display: 'flex',
    alignItems: 'center',
    height: '22px',
    paddingRight: '8px',
    cursor: 'pointer',
    userSelect: 'none' as const,
  },
  treeItemSelected: {
    backgroundColor: 'var(--component-explorer-list-activeSelectionBackground)',
    color: 'var(--component-explorer-list-activeSelectionForeground)',
  },
  treeItemHover: {
    backgroundColor: 'var(--component-explorer-list-hoverBackground)',
  },
  treeItemChevron: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '16px',
    height: '16px',
    color: 'var(--component-explorer-foreground)',
    opacity: 0.8,
    cursor: 'pointer',
  },
  treeItemChevronPlaceholder: {
    width: '16px',
  },
  treeItemIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '16px',
    height: '16px',
    marginRight: '4px',
  },
  treeItemLabel: {
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap' as const,
    fontSize: '13px',
  },
  treeItemCount: {
    marginLeft: '8px',
    fontSize: '11px',
    color: 'var(--component-explorer-descriptionForeground)',
  },
  mainContent: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'var(--component-explorer-editor-background)',
    color: 'var(--component-explorer-descriptionForeground)',
    fontSize: '14px',
  },
  propertiesPanel: {
    padding: '12px',
  },
  propertyRow: {
    marginBottom: '12px',
  },
  propertyLabel: {
    fontSize: '12px',
    color: 'var(--component-explorer-foreground)',
    marginBottom: '4px',
  },
  propertyDescription: {
    fontSize: '11px',
    color: 'var(--component-explorer-descriptionForeground)',
    marginTop: '2px',
  },
  propertyInput: {
    width: '100%',
    height: '26px',
    padding: '0 8px',
    fontSize: '13px',
    color: 'var(--component-explorer-input-foreground)',
    backgroundColor: 'var(--component-explorer-input-background)',
    border: '1px solid var(--component-explorer-input-border, transparent)',
    borderRadius: '2px',
    outline: 'none',
    boxSizing: 'border-box' as const,
  },
  propertySelect: {
    width: '100%',
    height: '26px',
    padding: '0 8px',
    fontSize: '13px',
    color: 'var(--component-explorer-dropdown-foreground)',
    backgroundColor: 'var(--component-explorer-dropdown-background)',
    border: '1px solid var(--component-explorer-dropdown-border)',
    borderRadius: '2px',
    outline: 'none',
    boxSizing: 'border-box' as const,
    cursor: 'pointer',
  },
} as const;

// Helper to merge styles
export function mergeStyles(...styleObjects: (React.CSSProperties | undefined | false)[]): React.CSSProperties {
  return Object.assign({}, ...styleObjects.filter(Boolean));
}
